import { render } from "./Profile.vue?vue&type=template&id=4d46ea15&scoped=true"
import script from "../js/profile.js?vue&type=script&lang=js&external"
export * from "../js/profile.js?vue&type=script&lang=js&external"

import "./Profile.vue?vue&type=style&index=0&id=4d46ea15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d46ea15"]])

export default __exports__